import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  validate(event) {
    const input = event.target
    if (input.pattern && input.validity.patternMismatch) {
      input.classList.add('is-invalid')
    } else {
      input.classList.remove('is-invalid')
    }
  }
}
